import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import axios from 'axios'
import VueAxios from 'vue-axios'
// import { wrapper } from 'axios-cookiejar-support';
// import { CookieJar } from 'tough-cookie';

axios.defaults.withCredentials = true;
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.use(BootstrapVueIcons)
// const jar = new CookieJar();
// const client = wrapper(axios.create({ jar }));
// Vue.axios.defaults.withCredentials = true;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
